import { QueryClient, QueryClientProvider } from 'react-query';
import { LicenseInfo } from '@mui/x-license-pro';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { CustomNotificationsProvider } from '@cellebrite/saas-ui-common';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { configureAxios } from './common/utils/configureAxios';
import App from './investigate/App';
import AuthContextProvider from './common/contexts/authContext';
import GlobalContextProvider from './common/contexts/globalContext';
import { i18nInit } from './common/utils/i18nInit';
import './common/scss/common.scss';
import './common/scss/images-carousel.scss';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

LicenseInfo.setLicenseKey(
    '434d5243180623fd88f983e9e703503aTz05Mjg1OCxFPTE3NTA1MDY2OTM4OTksUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=',
);

declare global {
    interface Window {
        pendo: any;
    }
}

configureAxios();
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

i18nInit().then(() => {
    const root = createRoot(document.getElementById('root'));
    root.render(
        <CustomNotificationsProvider>
            <QueryClientProvider client={queryClient}>
                <AuthContextProvider>
                    <GlobalContextProvider>
                        <BrowserRouter basename={process.env.PUBLIC_URL}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <App />
                            </LocalizationProvider>
                        </BrowserRouter>
                    </GlobalContextProvider>
                </AuthContextProvider>
            </QueryClientProvider>
        </CustomNotificationsProvider>,
    );
});
